<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="$router.go(-1)"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Mock AI Interview
		</header>
		<main class="ai-interview-container">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
					@click="$router.go(-1)"
				/>
				Mock AI Interview
			</div>
			<div class="ai-container">
				<div>
					<div class="fam-mont fw-M fs-32 mob-fs-18 text-blue">
						Take AI Interview
					</div>
					<div class="fam-lato fw-R fs-20 mob-fs-13 text-darkgrey ai-mt-12">
						Practice with AI- Powered Interviews
					</div>
				</div>
				<img
					id="hideinlaptop"
					class="w-100"
					src="../../assets/img/aiInterview/ai-back-mob.svg"
					alt=""
				/>
				<div
					class="ai-gift-tag fam-lato fw-LM fs-18 mob-fs-14 text-darkgrey d-flex gap-3"
				>
					<img src="../../assets/img/aiInterview/ai-gift.svg" alt="" />
					<span class="text-decoration-line-through">
						You have 1 Free Interview
					</span>
					<span> Free for a Limited Time </span>
				</div>
				<div class="ai-tag-gradient">
					<img src="../../assets/img/aiInterview/ai-inter.svg" alt="" />
					<div class="ml-3">
						<div class="fam-mont fw-M fs-16 mob-fs-13 text-blue">
							AI Interviewer
						</div>
						<div class="fam-lato fw-R fs-14 mob-fs-11 text-464667">
							Learn practical, in-demand skills to stay ahead in your career
							journey.
						</div>
					</div>
				</div>
				<div class="ai-tag-gradient">
					<img src="../../assets/img/aiInterview/real-dyn.svg" alt="" />
					<div class="ml-3">
						<div class="fam-mont fw-M fs-16 mob-fs-13 text-blue">
							Real Dynamic Interview Questions
						</div>
						<div class="fam-lato fw-R fs-14 mob-fs-11 text-464667">
							Learn practical, in-demand skills to stay ahead in your career
							journey.
						</div>
					</div>
				</div>
				<div class="ai-tag-gradient">
					<img src="../../assets/img/aiInterview/personal-feed.svg" alt="" />
					<div class="ml-3">
						<div class="fam-mont fw-M fs-16 mob-fs-13 text-blue">
							Personalized Feedback
						</div>
						<div class="fam-lato fw-R fs-14 mob-fs-11 text-464667">
							Learn practical, in-demand skills to stay ahead in your career
							journey.
						</div>
					</div>
				</div>
				<div id="hideinmobile">
					<b-button class="candash-addBtn" @click="takeAnInterview()">
						Take an Interview
					</b-button>
				</div>
				<img
					id="hideinmobile"
					style="position: absolute; right: 0px; bottom: 0px; z-index: 1"
					src="../../assets/img/aiInterview/ai-back.svg"
					alt=""
				/>
			</div>
			<div id="hideinlaptop" class="mobjd-applied-footer w-100 px-3">
				<b-button class="candash-addBtn w-100" @click="takeAnInterview()"
					>Take an Interview</b-button
				>
			</div>
		</main>
	</div>
</template>

<script>
export default {
	name: "TakeAiInterview",
	methods: {
		takeAnInterview() {
			console.log(this.$route.query.bycompany, this.$route.query);
			if (this.$route.query.bycompany) {
				this.$router.push({
					name: "systemcheck",
					query: { fromAiInterview: true, ...this.$route.query },
				});
			} else {
				this.$router.push({
					name: "AiSkillInterview",
					query: this.$route.query,
				});
			}
		},
	},
};
</script>

<style>
.ai-interview-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.ai-interview-container .cand-header {
	background-color: #20639b14;
}
.ai-container {
	display: flex;
	flex-direction: column;
	gap: 30px;
	height: calc(100vh - 148px);
	background: #f0f5ff;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	width: 100%;
	position: relative;
	overflow: hidden;
	border-radius: 5px;
	padding: 30px;
	overflow-y: auto;
	overflow-x: hidden;
}
.ai-container .candash-addBtn {
	font-size: 14px !important;
	font-weight: 700 !important;
	padding: 10px 32px !important;
	width: 350px;
}
.ai-gift-tag {
	background: #cce4fc75;
	border-radius: 6px;
	width: 600px;
	justify-content: center;
	padding-block: 5px;
}
.ai-tag-gradient {
	background: linear-gradient(270deg, #f0f5ff -30.85%, #ffffff 100%);
	border-radius: 8px;
	padding: 10px;
	display: flex;
	width: 600px;
}
@media (max-width: 1028px) {
	.ai-interview-container {
		background-color: #f5f9ff;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		) !important;
		padding: 0px !important;
		overflow: auto !important;
		position: fixed !important;
		top: unset !important;
		display: unset !important;
	}
	.ai-container {
		display: flex;
		flex-direction: column;
		gap: 30px;
		height: 92%;
		background: unset;
		border: unset;
		box-shadow: unset;
		width: 100%;
		position: relative;
		overflow: auto;
		border-radius: 5px;
		padding: 15px;
	}
	.ai-gift-tag {
		background: #cce4fc75;
		border-radius: 6px;
		width: 100%;
		justify-content: center;
		padding-block: 5px;
	}
	.ai-tag-gradient {
		background: linear-gradient(270deg, #f0f5ff -30.85%, #ffffff 100%);
		border-radius: 8px;
		border: 1px solid #20639b33;
		padding: 10px;
		display: flex;
		width: 100%;
	}
	.ai-mt-12 {
		margin-top: 12px;
	}
}
</style>
